/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { GetMeOrgsResp } from './GetMeOrgsResp';
import {
    GetMeOrgsRespFromJSON,
    GetMeOrgsRespFromJSONTyped,
    GetMeOrgsRespToJSON,
} from './GetMeOrgsResp';

/**
 * 
 * @export
 * @interface GetMeOrgs200Response
 */
export interface GetMeOrgs200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetMeOrgs200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetMeOrgs200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {GetMeOrgsResp}
     * @memberof GetMeOrgs200Response
     */
    result: GetMeOrgsResp;
}

/**
 * Check if a given object implements the GetMeOrgs200Response interface.
 */
export function instanceOfGetMeOrgs200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetMeOrgs200ResponseFromJSON(json: any): GetMeOrgs200Response {
    return GetMeOrgs200ResponseFromJSONTyped(json, false);
}

export function GetMeOrgs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMeOrgs200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': GetMeOrgsRespFromJSON(json['result']),
    };
}

export function GetMeOrgs200ResponseToJSON(value?: GetMeOrgs200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': GetMeOrgsRespToJSON(value.result),
    };
}

